import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/services/app-config.service";
import { ReportingDashboarAPIConstant } from "../constants/reporting-dashboard.constant";

@Injectable({
    providedIn: 'root'
})
export class ReportingDashboardService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    apiUrl = AppConfig.settings.apiUrl;

    constructor(private http: HttpClient) { }

    getFacilityFieldMappings() {
        return this.http.get(`${this.apiUrl}${ReportingDashboarAPIConstant.GETFACILITYFIELDMAPPINGS}`, this.httpOptions);
    }

    getChangeRequestStatistics() {
        return this.http.get(`${this.apiUrl}${ReportingDashboarAPIConstant.GETCHANGEREQUESTSTATISTICS}`, this.httpOptions);
    }

    getGraphData(facilities: string, startDate: any, endDate: any, graphNumber: number) {

        let graphAPI = "";

        if(graphNumber == 1){
            graphAPI = ReportingDashboarAPIConstant.GETPRIORITYCOMPLIANCESTATISTICS;
        }
        else if(graphNumber == 2){
            graphAPI = ReportingDashboarAPIConstant.GETMONTHCOMPLIANCESTATISTICS;
        }
        else if(graphNumber == 3){
            graphAPI = ReportingDashboarAPIConstant.GETACDBSCCOMPLIANCESTATISTICS;
        }
        else if(graphNumber == 4){
            graphAPI = ReportingDashboarAPIConstant.GETAVERAGEOPENDAYSCOMPLIANCESTATISTICS;
        }
        
        let params = [];
        if (facilities) {
            params.push(`facilities=${facilities}`);
        }
        if (startDate) {
            params.push(`${graphNumber == 3 ? 'startYear' : 'startDate'}=${startDate}`);
        }
        if (endDate) {
            params.push(`${graphNumber == 3 ? 'endYear' : 'endDate'}=${endDate}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        

        return this.http.get(`${this.apiUrl}${graphAPI}${url}`, this.httpOptions);
    }
}